import { writable, readable } from "svelte/store";
import { ListStore } from "../common/list-store/entity";

const userTemplate = readable({
  id: "",
  initial: "",
  middleName: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  birthDate: "",
  ehLevel: "EH3",
  secondFactor: "Geen",
  existingAccount: false,
  idType: "Identiteitskaart",
  documentNumber: "",
  documentExpiryDate: "",
  idCountry: "Nederland",
  allOrganizations: false,
  organizations: [],
  admin: false,
  employed: false,
});

export let currentUser = writable({ ...userTemplate });

let storedUsers = !sessionStorage.getItem("userStore")
  ? []
  : JSON.parse(sessionStorage.getItem("userStore"));

export const userStore = writable(storedUsers);

userStore.subscribe((value) => {
  sessionStorage.setItem("userStore", JSON.stringify(value));
});

export let userList = new ListStore(userTemplate, userStore, currentUser);
